import { cva } from "class-variance-authority";

export { default as Tag } from "./Tag.vue";

export const tagVariants = cva(
  "inline-flex items-center rounded-full font-medium w-fit whitespace-nowrap shrink-0 border transition-colors",
  {
    variants: {
      variant: {
        primary: "bg-blue-50 text-blue-600 border-blue-200",
        success: "bg-green-50 text-green-600 border-green-200",
        danger: "bg-red-50 text-red-600 border-red-200",
        warning: "bg-amber-50 text-amber-600 border-amber-200",
        rose: "bg-rose-50 text-rose-600 border-rose-200",
        violet: "bg-violet-50 text-violet-600 border-violet-200",
        teal: "bg-teal-50 text-teal-600 border-teal-200",
        orange: "bg-orange-50 text-orange-600 border-orange-200",
        default: "bg-muted text-muted-foreground border-border",
        outline: "bg-background text-foreground border-border",
      },
      size: {
        xs: "text-[9px] h-5 px-1 gap-1 leading-none",
        sm: "text-[11px] h-6 px-2 gap-1 leading-none",
        md: "text-[13px] h-7 px-3 gap-1.5 leading-none",
        lg: "text-[14px] h-8 px-3.5 gap-2 leading-none",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  }
);

export const TAG_ROTATION_VARIANTS = [
  "primary",
  "rose",
  "success",
  "violet",
  "teal",
  "orange",
  "warning",
];

export function pickTagVariant(key) {
  if (!key) return "primary";
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash << 5) - hash + key.charCodeAt(i);
    hash |= 0;
  }
  return TAG_ROTATION_VARIANTS[Math.abs(hash) % TAG_ROTATION_VARIANTS.length];
}
